import { Box, Chip, Stack } from "@mui/material";
import { useStyle } from "./style";
import { PaletteColorKeys } from "src/theme/themeConfiguration";
import { useDeviceType } from "@hook/useDeviceType";

export interface ITagProps {
    label: string;
    variant: PaletteColorKeys;
}

export const Tag = (props: ITagProps) => {
    const { label, variant } = props;
    const { isMobile } = useDeviceType();
    const { classes } = useStyle({ chipVariant: variant });

    const renderChip = () => (
        <Chip avatar={<Box className={classes.chipCircle} />} className={classes.chip} label={label} />
    );

    if (isMobile) {
        return (
            <Stack alignItems="center" marginTop={1}>
                {renderChip()}
            </Stack>
        );
    }

    return renderChip();
};
